export const NOTIFICATION_MARK_ALL_AS_READ = "NOTIFICATION_MARK_ALL_AS_READ";
export const NOTIFICATION_GET_ALL = "NOTIFICATION_GET_ALL";
export const APPROVE_TO_CONNECT_ACCOUNT_WITH_SCHOOL = "APPROVE_TO_CONNECT_ACCOUNT_WITH_SCHOOL";